export const customerNumberIdRegex = /^[A-Za-z0-9]+$/g;
